interface SocketURLProps {
	isDev?: boolean;
	customHostName?: string;
}

export function getSocketURL({ isDev, customHostName }: SocketURLProps) {
	let hostname = '';
	const wsEndpoint = '/wsbridge/v1/game/orbital.cosmoclassic';

	if (customHostName) {
		hostname = customHostName;
	} else if (isDev) {
		hostname = 'dev.orbitalgaming.io';
	} else {
		hostname = window.location.hostname;
	}

	return `wss://${hostname}${wsEndpoint}`;
}
